import $ from 'jquery';
import 'modaal';

const nodeSelector = 'node';

class ConvertToModaal {
  constructor(node, settings) {
    this.old = node;
    this.settings = settings;
    this.type = 'image';
    this.image = true;

    // Add custom video type.
    if (this.settings.isVideo) {
      this.type = 'video';
    }

    // Remove unneeded attributes and classes.
    this.old.removeAttribute('rel');
    this.old.classList.remove('lightbox-processed');

    // Clone the node to insure removal of previously set lightbox listeners functions.
    this.new = this.old.cloneNode(true);
    this.old.parentNode.replaceChild(this.new, this.old);

    // Check if modaal should be opened.
    this.modalCheck();

    // Add attributes if modaal should be opened.
    if (this.image) {
      // Add Modaal attributes for this particular link type.
      this.new.setAttribute('data-modaal-type', this.type);

      // If this is an image gallery, add the group data attribute.
      if (this.settings.isGallery) {
        this.new.setAttribute('data-group', 'gallery');
      }
    }

    // Add the caption, if applicable.
    const caption = this.new.querySelector('.caption');
    if (caption && caption.textContent.length) {
      this.caption = caption.textContent;
    }

    if (this.caption) {
      this.new.setAttribute('data-modaal-desc', this.caption);
    }

    // Add a replacement listener for our new link.
    this.new.addEventListener('click', this.clickHandler.bind(this));
  }

  clickHandler(event) {
    if (this.image) {
      event.preventDefault();
      $(this.new).modaal({
        type: this.type,
        start_open: true,
      });
    }
  }

  modalCheck() {
    // const $link = $(this.new);
    const $img = $('img', $(this.new));
    const $src = $img.attr('src').split('/');
    const $file = $src[$src.length - 1];
    const $filename = $file.split('?')[0];
    if ($(this.new).attr('href').indexOf($filename) < 0) {
      this.image = false;
    }
  }
}

export default class Modaal {
  constructor(parent, selector) {
    const settings = {
      isGallery: parent.querySelectorAll('img').length > 1,
    };

    if (parent.classList.contains(nodeSelector)) {
      // Process individual node.
      parent.querySelectorAll(selector).forEach((child) => {
        settings.isVideo = child.parentNode.classList.contains('field-video');
        child.ConvertToModaal = new ConvertToModaal(child, settings);
      });
    } else {
      // Process group of nodes.
      parent.querySelectorAll(nodeSelector).forEach((node) => {
        node.querySelectorAll(selector).forEach((child) => {
          settings.isVideo = child.parentNode.classList.contains('field-video');
          child.ConvertToModaal = new ConvertToModaal(child, settings);
        });
      });
    }
  }
}
